import { useField } from "formik";
import { useEffect, useState } from "react";

import { TagGroupSelect } from "../components/tag-group/TagGroupSelect";
import {
  TaggableValue,
  TagGroupSelectProps,
} from "../components/tag-group/types";

interface Props extends TagGroupSelectProps<object, TaggableValue> {
  name: string;
  onChange?: (tags: Record<string, any>[]) => void;
}

export function TagGroupSelectFormikField(props: Props) {
  const { name, testID, label, values, onChange, info, description } = props;

  const [field, meta, helpers] = useField(name);
  const [dynamicValues, setDynamicValues] = useState(values);

  useEffect(() => {
    setDynamicValues(values);
  }, [values]);

  return (
    <TagGroupSelect
      label={label}
      testID={testID}
      name={name}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      onBlur={() => helpers.setTouched(true)}
      values={dynamicValues}
      handleCreateNewValue={setDynamicValues}
      selectedValues={field.value ?? []}
      setSelectedValues={(tags: Record<string, any>[]) => {
        helpers.setValue(tags);
        onChange?.(tags);
      }}
      info={info}
      description={description}
    />
  );
}
